import { ArticleBrandId, ArticleCategory } from "entities/manageArticles/types";
import { FC } from "react";
import { generatePath, useParams } from "react-router-dom";
import { MANAGE_ARTICLES_PATH } from "shared/routes/paths";
import { DocumentIcon } from "shared/theme/icons/DocumentIcon";
import { QuestionIcon } from "shared/theme/icons/QuestionIcon";
import { StyledSideBarContainer, StyledSideBarLink } from "./styled";
import "./styled";

type SideBarManageArticlesProps = {
  brandId: ArticleBrandId;
};

const SideBarManageArticles: FC<SideBarManageArticlesProps> = ({ brandId }) => {
  const { categoryId } = useParams();

  const getManageArticlesGroupPath = (category: ArticleCategory) =>
    generatePath(MANAGE_ARTICLES_PATH, {
      brandId,
      categoryId: category,
    });

  const manageArticlesByCategory = [
    {
      id: ArticleCategory.LEGAL,
      name: "Legal",
      path: getManageArticlesGroupPath(ArticleCategory.LEGAL),
      Icon: DocumentIcon,
    },
    {
      id: ArticleCategory.HELP,
      name: "Help",
      path: getManageArticlesGroupPath(ArticleCategory.HELP),
      Icon: QuestionIcon,
    },
  ];

  const filteredCategories =
    brandId === ArticleBrandId.FREE
      ? manageArticlesByCategory.filter(
          (category) => category.id === ArticleCategory.LEGAL,
        )
      : manageArticlesByCategory;

  return (
    <StyledSideBarContainer>
      {filteredCategories.map(({ id, name, path, Icon }) => (
        <StyledSideBarLink to={path} key={id} isActive={categoryId === id}>
          <Icon />
          {name}
        </StyledSideBarLink>
      ))}
    </StyledSideBarContainer>
  );
};

export default SideBarManageArticles;
